import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_26: FaireProductEntity = {
  token: "legacy_prod_abbott-26",
  type: "product",
  name: 'Small Hanging Mouse Dark Brown 2" H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/edc89de6a1a119ab4cddbf913bf90e65fe1a1a740e3eaf8a5f23af66d697fbe4.jpeg",
  priceDollars: 12,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
